/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1627
 */

var r = require(/* 194 */"./1648/194")
require(/* 534 */"./1282/534")(r.JSON, "JSON", true)
